var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"exhibit__normalCardContainer container"},_vm._l((_vm.exhibitLists),function(exhibit,index){return _c('ExhibitCardNormal',{key:index,attrs:{"index":index,"exhibit":exhibit}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }